export var valuesSessionInformationDirection = ["Session", "Participant", "Both"];
/*

*/ 
//# sourceMappingURL=SessionInformationDirection.js.map